import { usePlanRoot } from "lib/use-plan-root"
import { useState } from "react"
import { findSchedulesInRegime } from "routes/asset-register/plugins/schedules-out-of-date/controller/find-schedules-in-regime"
import { emptyArray } from "lib/empty-array"
import { DialogBox } from "lib/@components/dialogBox"
import { If } from "lib/@components/switch"
import { RadioButtonGroup } from "lib/@components/radio-button-group/radio-button-group"
import { Else } from "lib/@components/else"
import { Typography } from "@mui/material"
import LoadingScreen from "minimals-template/components/LoadingScreen"
import { joinList } from "lib/join-list"

export function OutOfDateDialog({ scheduleId, item: { idOfScheduleInRegime: id, where, title, regimeVersion } }) {
    const regime = usePlanRoot()
    const [updateType, setUpdateType] = useState("one")
    const schedules =
        findSchedulesInRegime.useResults.busy("Retrieving schedules", regime.id, scheduleId, regimeVersion) ??
        emptyArray
    return schedules === emptyArray ? (
        <LoadingScreen />
    ) : (
        <DialogBox value={updateType === "one" ? [id] : schedules.map("id")}>
            <If truthy={schedules.length > 1}>
                <RadioButtonGroup
                    setterFunction={setUpdateType}
                    value={updateType}
                    sx={{ p: 2 }}
                    labelSx={{ fontSize: 13 }}
                    label="Which schedules do you want to update?"
                    options={[
                        {
                            label: `Only the one "${title}" schedule you selected, located in "${where}"`,
                            value: "one",
                        },
                        {
                            label: `All uses of the "${title}" schedule, it is used in ${schedules?.length} places including ${joinList(schedules.slice(0, 6).map((c) => `"${c.where}"`))}?`,
                            value: "all",
                        },
                    ]}
                />
                <Else>
                    <Typography variant="body1">
                        Are you sure you want to update the &quot;{title}&quot; schedule in &quot;{where}&quot;?
                    </Typography>
                </Else>
            </If>
        </DialogBox>
    )
}
